import NiceModal, { useModal } from '@ebay/nice-modal-react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

export const AbandonProfileModal = NiceModal.create(() => {
  const modal = useModal()
  const { t } = useTranslation()

  return (
    <Dialog
      open={modal.visible}
      onClose={() => modal.remove()}
      sx={{
        '& .MuiDialog-paper': {
          width: '37.5rem',
          padding: '1.5rem'
        }
      }}
    >
      <DialogTitle sx={{ padding: '1.5rem' }}>
        <Typography fontWeight='bold' variant='h6' component='span'>
          {t('abandon_profile_modal.title')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: '1.5rem' }}>
        <Typography variant='body1' marginBottom={'0.5rem'}>
          {t('abandon_profile_modal.text')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={() => modal.remove()}
          sx={{ color: 'main.primary', textTransform: 'capitalize' }}
        >
          {t('common.cancel')}
        </Button>
        <Button
          variant='contained'
          component={Link}
          to='/companies'
          onClick={() => modal.remove()}
          sx={{ textTransform: 'capitalize', color: 'main.primary' }}
        >
          {t('abandon_profile_modal.logout')}
        </Button>
      </DialogActions>
    </Dialog>
  )
})
